export default "__VITE_ASSET__$nfD_5KH__"